import React from 'react';
import { 
    Create, 
    SimpleForm, 
    ReferenceInput,
    SelectInput,
    AutocompleteInput,
    NumberInput,
    TextInput,
    BooleanInput,
    required
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";

export const FeeConcessionCreate = props => {
    return (
        <React.Fragment>
            <Create label="Create Concession" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />} className="main-form">
                    <ReferenceInput 
                        source="enrollment_id" 
                        reference="student-enrollment"
                        label="Student Enrollment"
                        fullWidth={true}
                        filterToQuery={searchText => ({ 'enrollment_number': searchText })}
                    >
                        <AutocompleteInput 
                            optionText={(record) => `${record.enrollment_number} - ${record.student_name}`}
                            shouldRenderSuggestions={(val) => { return val && val.trim().length >= 2 }}
                            validate={[required()]} 
                        />
                    </ReferenceInput>
                    
                    <SelectInput 
                        source="concession_type" 
                        label="Concession Type" 
                        choices={[
                            { id: 'scholarship', name: 'Scholarship' },
                            { id: 'sibling_discount', name: 'Sibling Discount' },
                            { id: 'merit_based', name: 'Merit Based' },
                            { id: 'financial_aid', name: 'Financial Aid' },
                            { id: 'other', name: 'Other' },
                        ]} 
                        validate={[required()]}
                        defaultValue="scholarship"
                        fullWidth={true}
                        className="first_inline_input"
                    />
                    
                    <NumberInput 
                        source="concession_percentage" 
                        label="Concession Percentage (%)"
                        fullWidth={true}
                        className="last_inline_input"
                        min={0}
                        max={100}
                        helperText="Percentage (0-100) - Applied ONLY to Tuition Fee"
                    />
                    
                    <NumberInput 
                        source="concession_amount" 
                        label="Concession Amount (Fixed)"
                        fullWidth={true}
                        min={0}
                        helperText="Fixed amount - Applied ONLY to Tuition Fee (not to registration, study material, deliverable, or tech support fees). Enter percentage above OR fixed amount here"
                    />
                    
                    <TextInput 
                        source="reason" 
                        label="Reason for Concession"
                        fullWidth={true}
                        multiline
                        rows={3}
                        validate={[required()]}
                    />
                    
                    <BooleanInput 
                        source="is_active" 
                        label="Active" 
                        defaultValue={true}
                    />
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
}
